import _Object$assign from 'babel-runtime/core-js/object/assign';
import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import _ from 'lodash';
import productMaterialEvent from '@pt/components/product-material-event.vue';
import productMaterialInteractiveType from '@pt/components/product-material-interactive-type.vue';
import PtButton from '@com/pt-components/pt-button/index.vue';
import { getPSProjectInfo, savePsProject } from '@ps/api/project';
import { saveDmakerCustom } from '@/api/creative/custom';
import { getGmakerProjectInfo } from '@pt/api/gmaker/project';
import { t } from '@/lang';
import store from '@ps/store';
import { VpBaseMethods } from '@ps/bridge/qc/vp/config';
import { materialMakeFrom } from '@pt/utils/push.js';
import { ProductType } from '@pt/enums/product';
// import { isIvPage } from '@ps/router/config'
// import router from '@pt/router'

export default {
  props: ['data', 'callback', 'project_type', 'isCustom', 'disabled', 'toPsEdit', 'title', 'source', 'customSubmitTitle', 'hideCannelButton'],
  components: {
    productMaterialEvent: productMaterialEvent,
    productMaterialInteractiveType: productMaterialInteractiveType,
    PtButton: PtButton
  },
  data: function data() {
    return {
      dialogVisible: false,
      materialEvent: {
        title: t('playTurbo.common.eventInfoConfirm.title', {
          title: this.title
        }),
        subtitle: '',
        visible: false,
        hideCancel: this.hideCannelButton || this.source === 'toolBarDownload' || this.source === 'preViewBarDownload',
        submitTitle: this.customSubmitTitle || (this.source === 'toolBarDownload' || this.source === 'preViewBarDownload' ? t('playTurbo.whole.gotit') : t('playTurbo.common.eventInfoConfirm.info'))
      },
      materialInteractiveType: {
        title: t('playTurbo.versionlist.materialInteractive.gameStep'),
        subtitle: t('playTurbo.versionlist.materialInteractive.gameJourney'),
        visible: false,
        callbackParam: '',
        submitTitle: t('playTurbo.versionlist.materialInteractive.download')
      }
    };
  },

  methods: {
    handleClick: function handleClick() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, apps, productType, hookWxgame, materialEvent, isNormMaterial, bar_material_event, _materialEvent;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.disabled) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                if (_this.isCustom) {
                  _context.next = 45;
                  break;
                }

                _this.$emit('changeLoading', true);
                _context.next = 6;
                return _this.getProjectData(_this.data.id);

              case 6:
                res = _context.sent;
                apps = _.get(res, 'data.data.product_id') || _.get(res, 'data.product_id') || 0;
                productType = _.get(res, 'data.product_info.type');

                hookWxgame = function hookWxgame(productType, materialEvent) {
                  // 如果产品关联了微信小游戏，不需要跳转应用商店事件
                  if (productType === ProductType.WXGame) {
                    if (!materialEvent || !materialEvent.includes(VpBaseMethods.vpInstall)) {
                      materialEvent = materialEvent.split(',').filter(Boolean);

                      materialEvent.push(VpBaseMethods.vpInstall);

                      materialEvent = materialEvent.join(',');
                    }
                    return materialEvent;
                  }
                  return materialEvent;
                };

                materialEvent = _.get(res, 'data.material_event') || '';

                if (!(apps === 0)) {
                  _context.next = 16;
                  break;
                }

                _this.$emit('changeLoading', false);
                _this.dialogVisible = true;
                _context.next = 43;
                break;

              case 16:
                if (!(_this.project_type === 'playsmart' || _this.project_type === 'iv')) {
                  _context.next = 42;
                  break;
                }

                if (!(_this.source === 'toolBarDownload')) {
                  _context.next = 31;
                  break;
                }

                isNormMaterial = store.state.workspace.project.isNormMaterial;

                if (!isNormMaterial) {
                  _context.next = 25;
                  break;
                }

                _context.next = 22;
                return _this.$store.dispatch('workspace/project/updateMaterialEvent');

              case 22:
                _context.t0 = _context.sent;
                _context.next = 26;
                break;

              case 25:
                _context.t0 = [VpBaseMethods.vpInstall, VpBaseMethods.vpGameEnd].join();

              case 26:
                bar_material_event = _context.t0;


                bar_material_event = hookWxgame(productType, bar_material_event);

                _materialEvent = _this.handleMaterialEvent(bar_material_event);
                // eslint-disable-next-line max-depth

                if (!_materialEvent) {
                  _this.callbackCenter(bar_material_event);
                }
                return _context.abrupt('return', bar_material_event);

              case 31:

                materialEvent = hookWxgame(productType, materialEvent);

                // eslint-disable-next-line max-depth

                if (_this.handleMaterialEvent(materialEvent)) {
                  _context.next = 39;
                  break;
                }

                if (!(_this.source === 'psListDownload' || _this.source === 'preViewBarDownload')) {
                  _context.next = 36;
                  break;
                }

                _this.callbackCenter(materialEvent);
                return _context.abrupt('return', materialEvent);

              case 36:

                _this.callbackCenter();
                _context.next = 40;
                break;

              case 39:
                _this.$emit('changeLoading', false);

              case 40:
                _context.next = 43;
                break;

              case 42:
                _this.callbackCenter();

              case 43:
                _context.next = 46;
                break;

              case 45:
                _this.callbackCenter();

              case 46:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // ps素材是否包含试玩结束和跳转应用商店的事件
    handleMaterialEvent: function handleMaterialEvent(materialEvent) {
      // ps事件检测
      if (!materialEvent) {
        this.materialEvent.subtitle = t('playTurbo.common.eventInfoConfirm.emptyNullText', {
          info: this.title
        });
        this.materialEvent.visible = true;
        return true;
        // 试玩结束
      } else if (materialEvent === VpBaseMethods.vpGameEnd) {
        this.materialEvent.subtitle = t('playTurbo.common.eventInfoConfirm.emptyInstallText', {
          info: this.title
        });
        this.materialEvent.visible = true;
        return true;
        // 跳转应用商店事件
      } else if (materialEvent === VpBaseMethods.vpInstall) {
        this.materialEvent.subtitle = t('playTurbo.common.eventInfoConfirm.emptyGameEndText', {
          info: this.title
        });
        this.materialEvent.visible = true;
        return true;
      }
      return false;
    },
    handlePsEdit: function handlePsEdit() {
      if (this.source === 'preViewBarDownload' || this.source === 'toolBarDownload') {
        this.$emit('changeLoading', false);
        return;
      }
      this.toPsEdit();
    },
    handleUpdateSuccess: function handleUpdateSuccess() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res, materialEvent;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.project_type === 'playsmart')) {
                  _context2.next = 8;
                  break;
                }

                _context2.next = 3;
                return _this2.getProjectData(_this2.data.id);

              case 3:
                res = _context2.sent;
                materialEvent = _.get(res, 'data.material_event') || '';

                if (!_this2.handleMaterialEvent(materialEvent)) {
                  _this2.$emit('update');
                  if (_this2.source === 'toolBarDownload') {
                    _this2.callbackCenter();
                  } else {
                    _this2.callbackCenter(materialEvent);
                  }
                }
                _context2.next = 10;
                break;

              case 8:
                _this2.$emit('update');
                _this2.callbackCenter();

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    getProjectData: function getProjectData(id) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                res = void 0;

                if (!(_this3.project_type === 'playsmart' || _this3.project_type === 'iv')) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 4;
                return getPSProjectInfo({ id: id });

              case 4:
                res = _context3.sent;
                _context3.next = 10;
                break;

              case 7:
                _context3.next = 9;
                return getGmakerProjectInfo({ project_id: id });

              case 9:
                res = _context3.sent;

              case 10:
                return _context3.abrupt('return', res);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getPSProjectInfoByProjectId: function getPSProjectInfoByProjectId(projectId) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return getPSProjectInfo({
                  id: _this4.data.id
                });

              case 2:
                res = _context4.sent;
                return _context4.abrupt('return', { data: res });

              case 4:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    handleUpdatePSTmpl: function handleUpdatePSTmpl(params) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var res, code, errorMsg;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _context5.next = 3;
                return savePsProject(_extends({}, params, {
                  id: params.project_id
                }));

              case 3:
                res = _context5.sent;
                code = _.get(res, 'code');

                if (!(code === 1)) {
                  _context5.next = 11;
                  break;
                }

                errorMsg = _.get(res, 'msg');

                _this5.$message.error(errorMsg);
                return _context5.abrupt('return', _Promise.reject(_Object$assign({}, res, { message: errorMsg })));

              case 11:
                if (!(code === 0)) {
                  _context5.next = 13;
                  break;
                }

                return _context5.abrupt('return', {
                  data: {
                    data: {
                      project_id: params.project_id
                    }
                  }
                });

              case 13:
                _context5.next = 18;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5['catch'](0);

                console.error(_context5.t0);

              case 18:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[0, 15]]);
      }))();
    },


    // 回调调度，
    callbackCenter: function callbackCenter(param) {
      // 根据项目类型获取MaterialType
      // ps项目返回真实MaterialType
      // 定制项目MaterialType > 1，都传2
      var getMaterialTypeByProjectType = function getMaterialTypeByProjectType(projectType, materialType) {
        if (projectType === 'playsmart') {
          return materialType;
        }
        if (projectType === 'dmaker') {
          if (Number(materialType) > 1) {
            return 2;
          }
          return 1;
        }
        return materialType;
      };

      // 自由编辑和定制、互动视频项目，确认游戏步骤
      if (this.project_type === 'playsmart' || this.project_type === 'iv' || this.isCustom) {
        this.materialInteractiveType.visible = true;
        this.materialInteractiveType.callbackParam = param;
        this.materialInteractiveType.materialType = getMaterialTypeByProjectType(this.project_type, this.data.material_type);
      } else {
        this.callback(param);
      }
    },
    getInteractiveSave: function getInteractiveSave() {
      if (this.project_type === 'playsmart' || this.project_type === 'iv') {
        return savePsProject;
      }
      return saveDmakerCustom;
    },
    handleCancelInteractive: function handleCancelInteractive() {
      this.$emit('changeLoading', false);
    },
    handleInteractiveTypeCallback: function handleInteractiveTypeCallback(materialType) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var getMtType, postData;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                // 当用户选择2步以上，并且存在推断结果大于1，使用推断类型
                getMtType = function getMtType() {
                  if (_this6.data.predict_material_type && _this6.data.predict_material_type > 1 && materialType === 2) {
                    return _this6.data.predict_material_type;
                  }
                  return materialType;
                };

                postData = { material_type: getMtType() };

                if (_this6.isCustom) {
                  postData.custom_id = _this6.data.id;
                } else {
                  postData.id = _this6.data.id;
                }
                _context6.next = 5;
                return _this6.getInteractiveSave()(postData);

              case 5:
                if (!_this6.data.predict_material_type) {
                  _context6.next = 8;
                  break;
                }

                _context6.next = 8;
                return _this6.$store.dispatch('workspace/project/saveProjectMaterialInfo', {
                  materialType: getMtType()
                });

              case 8:
                _this6.callback(_this6.materialInteractiveType.callbackParam);

              case 9:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    },


    // 打开关联产品(也就是查看详情弹窗)
    jumpPage: function jumpPage() {
      this.dialogVisible = false;
      var data = {
        visible: true,
        title: this.data.name,
        id: this.data.id,
        type: this.project_type === 'playsmart' || this.project_type === 'iv' ? 'ps' : 'gmaker',
        project_type: this.project_type === 'dco' ? 'dco' : 'playable',
        from: materialMakeFrom.gmaker
      };
      if (this.project_type === 'playsmart' || this.project_type === 'iv') {
        data.from = materialMakeFrom.playsmart;
        data.project_type = 'playsmart';
      }
      // 下载之前打开详情弹框的逻辑和"查看详情"一致，存到store的信息会在<detail-tab />使用
      this.$store.commit('creative/detail/setDetailDialog', data);
    }
  }
};